module.exports = __webpack_public_path__ + "img/queda de folhas 4.7da3397d.webp";